"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsing_error = void 0;
const errors_1 = require("../../errors");
const Token = __importStar(require("../../token"));
const Value = __importStar(require("../../value"));
const Task = __importStar(require("../task"));
const TaskChart = __importStar(require("../task-chart"));
// NOTE three kinds of errors in the following function:
//   "(a b c"    --  "Found END_OF_TOKENS, while expecting: ..."
//   "(a b c))"  --  "Found ..., while expecting END_OF_TOKENS."
//   "(a ? c)"   --  "Found ..., while expecting: ..."
function parsing_error(schedule, grammar, start, end) {
    const i = find_last_index(schedule, start, end);
    if (index_still_can_scan_p(schedule, i)) {
        if (i === schedule.tokens.length - 1) {
            let s = "";
            s += "Found END_OF_TOKENS, ";
            s += "while expecting:\n";
            for (const task of TaskChart.tasks_at(schedule.chart, Math.max(0, i - 1))) {
                if (task_terminal_p(task)) {
                    s += " ";
                    const { value } = task.parts[task.progress.length];
                    s += Value.repr(value);
                    s += ":\n";
                    s += "     ";
                    s += Task.repr(task);
                    s += "\n";
                }
            }
            const span = schedule.tokens[i].span;
            return new errors_1.ParsingError(s, { span: { lo: span.hi, hi: span.hi } });
        }
        else {
            let s = "";
            s += `Found ${Token.report(schedule.tokens[i])}, `;
            s += "while expecting END_OF_TOKENS.\n";
            const span = schedule.tokens[i].span;
            return new errors_1.ParsingError(s, { span });
        }
    }
    else {
        let s = "";
        s += `Found ${Token.report(schedule.tokens[i])}, `;
        s += "while expecting:\n";
        for (const task of TaskChart.tasks_at(schedule.chart, i)) {
            if (task_terminal_p(task)) {
                s += " ";
                const { value } = task.parts[task.progress.length];
                s += Value.repr(value);
                s += ":\n";
                s += "     ";
                s += Task.repr(task);
                s += "\n";
            }
        }
        const span = schedule.tokens[i].span;
        return new errors_1.ParsingError(s, { span });
    }
}
exports.parsing_error = parsing_error;
function find_last_index(schedule, start, end) {
    let index = 0;
    for (let i = start; i < end; i++) {
        if (index_with_terminal_p(schedule, i)) {
            index = i;
        }
    }
    return index;
}
function index_with_terminal_p(schedule, i) {
    const tasks = Array.from(TaskChart.tasks_at(schedule.chart, i));
    return tasks.length !== 0 && tasks.some(task_terminal_p);
}
function task_terminal_p(task) {
    if (task.progress.length >= task.parts.length)
        return false;
    return Value.terminal_p(task.parts[task.progress.length].value);
}
function index_still_can_scan_p(schedule, i) {
    for (const task of TaskChart.tasks_at(schedule.chart, i)) {
        if (task_still_match_p(task, schedule.tokens[i]))
            return true;
    }
    return false;
    function task_still_match_p(task, token) {
        return (task.progress.length < task.parts.length &&
            Value.terminal_p(Task.next_part(task).value) &&
            Value.terminal_match(task.parts[task.progress.length].value, token));
    }
}
//# sourceMappingURL=schedule-parsing-error.js.map